import { apiRequest } from "./apiClient";

export type NotificationType =
  | "blog"
  | "offer"
  | "template"
  | "feature"
  | "billing"
  | "cv"
  | "system";

export type NotificationItem = {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  /** In-app path or absolute URL; empty when there is nowhere to go. */
  link: string;
  createdAt: string;
  read: boolean;
  broadcast: boolean;
};

export type NotificationFeed = {
  items: NotificationItem[];
  unreadCount: number;
  serverTime: string;
};

export const getNotifications = () =>
  apiRequest<NotificationFeed>("/notifications", { skipRefresh: true });

export const markNotificationsRead = (ids: string[]) =>
  apiRequest<void>("/notifications/read", {
    method: "POST",
    body: JSON.stringify({ ids }),
  });

export const markAllNotificationsRead = () =>
  apiRequest<void>("/notifications/read-all", { method: "POST" });

export const dismissNotification = (id: string) =>
  apiRequest<void>(`/notifications/${id}`, { method: "DELETE" });

// ─── Admin ────────────────────────────────────────────────────────────────

export type AdminBroadcastPayload = {
  type: NotificationType;
  title: string;
  body?: string;
  link?: string;
  expiresAt?: string;
};

export const createBroadcast = (payload: AdminBroadcastPayload) =>
  apiRequest<{ created: boolean }>("/notifications/admin/broadcasts", {
    method: "POST",
    body: JSON.stringify(payload),
  });
